// Document-head manager (no extra dependency) for programmatic SEO pages.
// Sets title, description, canonical, OG/Twitter tags and per-page JSON-LD.
export const SITE_URL = "https://nutriplate07.com";

const ensureMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  return el;
};

const ensureLink = (rel) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  return el;
};

export const setPageMeta = ({ title, description, path, jsonLd }) => {
  if (title) {
    document.title = title;
    ensureMeta('meta[property="og:title"]', { property: "og:title" }).setAttribute("content", title);
    ensureMeta('meta[name="twitter:title"]', { name: "twitter:title" }).setAttribute("content", title);
  }
  if (description) {
    ensureMeta('meta[name="description"]', { name: "description" }).setAttribute("content", description);
    ensureMeta('meta[property="og:description"]', { property: "og:description" }).setAttribute("content", description);
    ensureMeta('meta[name="twitter:description"]', { name: "twitter:description" }).setAttribute("content", description);
  }
  if (path) {
    const url = `${SITE_URL}${path}`;
    ensureLink("canonical").setAttribute("href", url);
    ensureMeta('meta[property="og:url"]', { property: "og:url" }).setAttribute("content", url);
  }
  // Per-page structured data: clear previous page's blocks, then inject.
  document.head.querySelectorAll("script[data-page-jsonld]").forEach((n) => n.remove());
  if (jsonLd) {
    const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    blocks.forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-page-jsonld", "1");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }
};
